<div class="price">
  <div class="line">
    <div class="label" i18n>
            Freight
        </div>
    <div class="amount">
      {{ baseFreight() | money:currency() }}
    </div>
  </div>
  @if (showDiscount()) {
    <div class="line">
      <div class="label" i18n>
            Discount
        </div>
      <div class="amount">
        {{ discount() | money:currency() }}
      </div>
    </div>
  }
  @if (showDiscount()) {
    <mat-divider></mat-divider>
  }
  @if (showDiscount()) {
    <div class="line">
      <div class="label" i18n>
            Freight Sub-Total
        </div>
      <div class="amount">
        {{ price.baseFreight | money:currency() }}
      </div>
    </div>
  }
  @for (surcharge of nonTaxSurcharges(); track surcharge) {
    <div class="line">
      <div class="label">
        {{ surcharge.description }}
      </div>
      <div class="amount">
        {{ surcharge.amount | money:currency() }}
      </div>
    </div>
  }
  <mat-divider></mat-divider>
  @if (showTaxes()) {
    <div class="line">
      <div class="label" i18n>
            Sub-Total
        </div>
      <div class="amount">
        {{ price.net | money:currency() }}
      </div>
    </div>
  }

  @for (tax of taxSurcharges(); track tax) {
    <div class="line">
      <div class="label">
        {{ tax.description }}
      </div>
      <div class="amount">
        {{ tax.amount | money:currency() }}
      </div>
    </div>
  }
  @if (showTaxes()) {
    <mat-divider></mat-divider>
  }
  <div class="line total">
    <div class="label" i18n>
            Total
        </div>
    <div class="amount">
      {{ price.gross | money:currency() }}
    </div>
  </div>
</div>
